import { Checkbox, DateRange } from "components/form_components/Inputs";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function ExpiryDateFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Expiry date filter">
      <DateRange name="expiryDate.filter" control={control} label="" />
      <Checkbox
        label=""
        name="expiryDate.hideNulls"
        control={control}
        fieldLabel="Hide leads that don't have an expiry date"
      />
    </StyledFilterContent>
  );
}

export default ExpiryDateFilterContent;
